module.exports = __webpack_public_path__ + "static/media/email-recent-alerts.6b1d00c2.png";